<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-media vertical-align="center">
          <template #aside>
            <div style="display:grid">
              <b-avatar
                size="62"
                :src="pendiente.foto_jug"
                :text="avatarText(pendiente.nombres)"
              />
              <small
                style="text-align:center;font-size:16px;font-weight: bolder"
                ># {{ pendiente.num_camiseta }}
              </small>
            </div>
          </template>
          <span class="font-weight-bold d-block text-nowrap">
            {{ pendiente.apellido }}
            {{ pendiente.nombre }}
          </span>
          <div class="text-muted small">{{ pendiente.ci_pasaporte }}</div>
          <small class="text-muted">{{ pendiente.categoria }}</small>
          <div class="text-muted text-uppercase small" style="">
            {{ pendiente.equipo }}
          </div>
        </b-media>
      </b-col>
      <b-col md="4">
        <b-media vertical-align="center">
          <span
            class="font-weight-bold d-block text-nowrap"
            style="font-size:12px"
          >
            {{ pendiente.motPrincipal }} en
          </span>
          <div class="text-muted small" style="">
            Etapa {{ pendiente.etapa }} - Fecha {{ pendiente.num_fecha }}
          </div>
          <div class="text-muted small" style="">
            {{ pendiente.local }} vs {{ pendiente.visita }}
          </div>
          <div class="text-muted small" style="">
            jugado el {{ pendiente.fecha_par }}
          </div>
        </b-media>
      </b-col>
      <b-col md="4">
        <b-media vertical-align="center">
          <div class="font-weight-bold d-block" style="font-size:12px">
            Quedan {{ pendiente.duracion }} partidos pendientes de un total de
            {{ pendiente.duracion_sancion }}
          </div>
          <div class="text-muted small" style="">
            buscar actualización en Etapa {{ pendiente.etapa_buscar }}
          </div>
          <b-button
            v-if="!showLoading"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            style="float:right"
            size="sm"
            @click="updateSancionPendiente(pendiente)"
          >
            Actualizar
          </b-button>
          <template v-if="showLoading">
            <b-spinner small />
            <span class="sr-only">Loading...</span></template
          >
          <span
            v-if="showError"
            style="font-size:10px; display:block; float:right; color:red"
            >No existen partidos para actualizar la sancion</span
          >
        </b-media>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BAvatar,
  BSpinner,
  BCol,
  BMedia,
  BRow,
  // xxxx,
  // xxxx,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { URL, USER } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BButton,
    BAvatar,
    BSpinner,
    BCol,
    BMedia,
    BRow,
  },
  props: {
    pendiente: Object,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const showError = ref(false)
    const { postApi } = apiCall()
    async function updateSancionPendiente() {
      // console.log(USER())
      // showLoading.value = true
      showLoading.value = true
      const dataSancion = {
        idEquipo: props.pendiente.idEquipo,
        duracion: props.pendiente.duracion,
        etapaBuscar: props.pendiente.etapa_buscar,
        idSancion: props.pendiente.id_sancion,
        idSancionPendiente: props.pendiente.id_sancion_pendiente,
        idJugador: props.pendiente.id_jugador,
        idAgrupacionPase: props.pendiente.agrupacion_pase,
        idUser: USER().id_usuario,
        idCampeonato: props.pendiente.id_campeonato,
        duracion_real: props.pendiente.duracion_sancion,
      }
      const path = 'ApiSanciones/updateSancionPendiente'
      const data = await postApi(URL, path, dataSancion)
      if (data.flag === 'si') {
        // console.log(data.flag)
        emit('sancionExitoPop', props.pendiente)
        showError.value = false
      } else {
        showError.value = true
      }
      showLoading.value = false
    }
    return {
      updateSancionPendiente,
      showLoading,
      showError,
      avatarText,
    }
  },
}
</script>
